<mat-sidenav-container class="mainWrapper blue_theme light-theme" autosize autoFocus dir="ltr">
  <mat-sidenav-content class="contentWrapper">
    <mat-toolbar class="topbar">
      <img src="./assets/images/logo.png" alt="Logo" class="logo" />
      <span class="flex-1-auto"></span>
      <button mat-raised-button color="primary" routerLink="/auth/login">Login</button>
    </mat-toolbar>
    <main class="pageWrapper maxWidth p-0">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
